<template>
  <v-card outlined class="py-3 px-5 w-100">
    <table class="w-100">
      <tr class="no-row-border">
        <td class="no-border" style="width: 170px"></td>
        <td
          class="table-title"
          style="direction: rtl"
          v-for="title in titles"
          :key="title"
        >
          {{ $t(`balanceResult.${title}`) }}
        </td>
      </tr>
      <tr v-for="(row, rowIndex) in product" :key="rowIndex">
        <td class="table-title no-col-border">
          <span v-if="rowIndex === 0">{{ $t("balanceResult.1") }}</span>
          <span v-else-if="rowIndex === 1">{{ $t("balanceResult.2") }}</span>
          <span v-else-if="rowIndex === 2">{{
            $t("balanceResult.GC/Mass")
          }}</span>
          <span v-else>{{ $t("balanceResult.Utilization") }}</span>
        </td>
        <td v-for="key in keys" :key="`${rowIndex}-${key}`">
          {{ row[key] }}
        </td>
      </tr>
    </table>
  </v-card>
</template>

<script>
import { PRODUCT_KEYS } from "../../views/balance/data";

export default {
  name: "ProductResult",

  props: {
    product: { type: Array, required: true },
  },

  data() {
    return {
      titles: ["pg", "png", "bustle"],
      keys: PRODUCT_KEYS,
    };
  },
};
</script>
